import React from 'react';
import PropTypes from 'prop-types';
import Spinner from 'common/components/spinner';
import './index.scss';

export default class ReportPreview extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    loading: PropTypes.bool,
    report: PropTypes.object,
    view: PropTypes.func,
  };

  static defaultProps = {
    form: {},
    loading: true,
    report: {},
    view: () => {},
  };

  render() {
    const View = this.props.view;
    return (
      <div className={'ReportPreview'}>
        {this.props.loading ? <Spinner /> : <View report={this.props.report} />}
      </div>
    );
  }
}
